<template>
    <el-footer  id="footer">
      <div class="foodertop">
        <i class="el-icon-thirdcustomization"></i>
        <div
          style="margin-left:15px;margin-top: 4px;display: flex;"
          id="footerprotuct"
        >
          <span>当前选择产品名称：</span>
          <!--<span style="margin-left: 10px;">NPP </span>
          <span style="margin-left: 10px;">O3廓线 </span>-->
        </div>
      </div>
      <div class="fooderboomnt">
        <i class="el-icon-thirdcalendar"></i>
        <div style="margin-left:15px;margin-top: 4px;display: flex;">
          <span>时间： <span id="fooderdata">2000-02-26 至 2012-02-26</span></span>
          <span style="margin-left:15px;">行政区：
            <span id="fooderxzqy"></span>
            <span id="drawstyle1"></span>
            <span id="drawstyle2"></span>
            <span id="drawstyle3"></span>
            <span id="drawstyle4"></span>
          </span>
          <span
            style="margin-left:15px;color: rgb(28, 203, 150);"
            id="footerarce"
          ></span>
          <span
            style="margin-left:15px;color: rgb(28, 203, 150);"
            id="footarea"
          ></span>
        </div>
      </div>
    </el-footer>
</template>

<script>
export default {
  name: 'mainFooter'

}
</script>
<style>
  .fooderboomnt {
  width: 100%;
  height: 29px;
  border-top: 1px rgb(175, 177, 193) solid;
  color: rgb(175, 177, 193);
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 2;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
}
.foodertop {
  width: 100%;
  height: 30px;
  color: rgb(175, 177, 193);
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 2;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/MainFooter.vue